<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton" defaultHref="settings"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title">Price</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content lines="none">
    <ion-list-header color="secondary">Please enter the pricing information:</ion-list-header>

    <ion-list lines="none">
        <form name="form" (ngSubmit)="f.form.valid && onSaveClick(f)" #f="ngForm" novalidate>

            <ion-item-divider color="tertiary">
                General Pricing Details
            </ion-item-divider>

            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">Price Name</ion-label>
                <ion-input data-test="priceName" color="secondary" type="text" name="priceName" #priceName="ngModel"
                    [ngClass]="{ 'is-invalid': f.submitted && priceName.invalid }" required
                    [(ngModel)]="price.priceName" id="priceName" autofocus="true">
                </ion-input>
                @if (submitted && priceName.invalid) {
  <div>
                    <div class="errorMsg">Price name is required.</div>
                </div>
}
            </ion-item>

            <ion-item (click)="onStatusClick()">
                <ion-label class="ion-text-wrap" position="stacked">Status</ion-label>
                <ion-input data-test="status" color="secondary" type="text" name="status" #status="ngModel"
                    [ngClass]="{ 'is-invalid': f.submitted && status.invalid }" required [(ngModel)]="price.status"
                    id="status" data-specid="status">
                </ion-input>
                @if (submitted && status.invalid) {
  <div data-specid="statusErr">
                    <div class="validationErrorMsg">Status is required.</div>
                </div>
}
            </ion-item>

            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">Pay As You Go: Base Price</ion-label>
                <ion-input data-test="paygBasePrice" color="secondary" type="number" name="paygBasePrice" #paygBasePrice="ngModel"
                    [ngClass]="{ 'is-invalid': f.submitted && paygBasePrice.invalid }" min="1" max="99999.99"
                    required [(ngModel)]="price.paygBasePrice" id="paygBasePrice" data-specid="paygBasePrice">
                </ion-input>
                @if (submitted && paygBasePrice.invalid) {
  <div>
                    <div class="errorMsg">Pay As You Go Base Price is required.</div>
                </div>
}
            </ion-item>

            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">Pay As You Go: Credits Cost Per Customer Message</ion-label>
                <ion-input data-test="creditsCostPerCustomerMsg" color="secondary" type="number" name="creditsCostPerCustomerMsg"
                    #creditsCostPerCustomerMsg="ngModel"
                    [ngClass]="{ 'is-invalid': f.submitted && creditsCostPerCustomerMsg.invalid }" min="1" max="10"
                    required [(ngModel)]="price.paygCreditsCostPerCustomerMsg" id="creditsCostPerCustomerMsg"
                    data-specid="creditsCostPerCustomerMsg">
                </ion-input>
                @if (submitted && creditsCostPerCustomerMsg.invalid) {
  <div>
                    <div class="errorMsg">Credits Cost Per Customer Message is required.</div>
                </div>
}
            </ion-item>
            
            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">Pay As You Go: Credits Cost Per Campaign Message</ion-label>
                <ion-input data-test="creditsCostPerCampaignMsg" color="secondary" type="number" name="creditsCostPerCampaignMsg"
                    #creditsCostPerCampaignMsg="ngModel"
                    [ngClass]="{ 'is-invalid': f.submitted && creditsCostPerCampaignMsg.invalid }" min="1" max="10"
                    required [(ngModel)]="price.paygCreditsCostPerCampaignMsg"
                    id="creditsCostPerCampaignMsg" data-specid="creditsCostPerCampaignMsg">
                </ion-input>
                @if (submitted && creditsCostPerCampaignMsg.invalid) {
  <div>
                    <div class="errorMsg">Credits Cost Per Campaign Message is required.</div>
                </div>
}
            </ion-item>
            
            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">Unlimited Monthly: Base Price</ion-label>
                <ion-input data-test="monthlyPrice" color="secondary" type="number" name="monthlyPrice" #monthlyPrice="ngModel"
                    [ngClass]="{ 'is-invalid': f.submitted && monthlyPrice.invalid }" min="1" max="99999.99"
                    required [(ngModel)]="price.unlimitedMonthlyBasePrice"
                    id="monthlyPrice" data-specid="monthlyPrice">
                </ion-input>
                @if (submitted && monthlyPrice.invalid) {
  <div>
                    <div class="errorMsg">Unlimited Monthly Price is required.</div>
                </div>
}
            </ion-item>

            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">Unlimited Yearly: Base Price</ion-label>
                <ion-input data-test="yearlyPrice" color="secondary" type="number" name="yearlyPrice" #yearlyPrice="ngModel"
                    [ngClass]="{ 'is-invalid': f.submitted && yearlyPrice.invalid }" min="1" max="99999.99"
                    required [(ngModel)]="price.unlimitedYearlyBasePrice"
                    id="yearlyPrice" data-specid="yearlyPrice">
                </ion-input>
                @if (submitted && monthlyPrice.invalid) {
  <div>
                    <div class="errorMsg">Unlimited Yearly Price is required.</div>
                </div>
}
            </ion-item>

            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">Ambassador Yearly: Base Price</ion-label>
                <ion-input data-test="ambassadorPrice" color="secondary" type="number" name="ambassadorPrice" #ambassadorPrice="ngModel"
                    [ngClass]="{ 'is-invalid': f.submitted && ambassadorPrice.invalid }" min="1" max="99999.99"
                    required [(ngModel)]="price.ambassadorYearlyBasePrice"
                    id="ambassadorPrice" data-specid="ambassadorPrice">
                </ion-input>
                @if (submitted && ambassadorPrice.invalid) {
  <div>
                    <div class="errorMsg">Ambassador Yearly Price is required.</div>
                </div>
}
            </ion-item>

        </form>
    </ion-list>
</ion-content>

<ion-footer>
    <ion-toolbar>
        <ion-button data-test="saveButton" color="secondary" expand="full" (click)="onSaveClick(f)">Save</ion-button>
    </ion-toolbar>
</ion-footer>